<template>
    <section class="map-balloon d-flex">
      <figure class="map-balloon__img">
          <img :src="building.preview" v-if="building.preview" height="110px">
          <img src="/assets/common/images/no-image-icon.jpg" height="110px" v-else>
      </figure>
        <div class="map-balloon__content">

            <h4 class="map-balloon__title">
                <a :href="'/novostroyki/' + building.slug" class="map-balloon__link" target="_blank">
                    ЖК «{{building.name}}»
                </a>
            </h4>
            <div class="map-balloon__status">
                <label class="mb-0">Статус:</label> <span class="map-balloon__status-value">{{building.status_title}}</span>
            </div>
            <div class="mb-1">
                <label class="mb-0">Район:</label> <a  v-if= "building.district" :href="'/ufa/' + building.district.slug" class="map-balloon__district" target="_blank">{{building.district.name}}</a>
            </div>
            <div class="d-flex justify-content-between">
                <div class="map-balloon__option-item" v-if="building.apartment_price_from || building.apartment_price_to">
                    <i aria-hidden="true" class="fas fa-home  list-item-options__icon"></i>
                    <span v-if="building.apartment_price_from">

                    от {{building.apartment_price_from}} &#8381;
                </span>

                </div>
                <div class="map-balloon__option-item" v-if="building.price_m2_from || building.price_m2_to">
                    <i class="list-item-options__icon list-item-options__icon--text">м<sup><small>2</small></sup></i>
                    <span v-if="building.price_m2_from">
                    от {{building.price_m2_from}}   &#8381;/м2
                </span>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            building: {
                type: Object,
            }
        }
    }
</script>
